/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadMiniDto } from '../../models/lexplus-upload-mini-dto';

export interface AnforderungDetailControllerUnlinkAnforderungDokumentV1$Params {
  anforderungsversionID: number;
  uploadID: string;
}

export function anforderungDetailControllerUnlinkAnforderungDokumentV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerUnlinkAnforderungDokumentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerUnlinkAnforderungDokumentV1.PATH, 'delete');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.path('uploadID', params.uploadID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadMiniDto>>;
    })
  );
}

anforderungDetailControllerUnlinkAnforderungDokumentV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/dokumente/{uploadID}';
